import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getTags(pageSize: number, pageNumber: number = 1) {
  try {
    const resp = await axios.get(
      `/api/tag/?pageSize=${pageSize}&pageNumber=${pageNumber}`
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
